import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { StyledNormalDescription, StyledDescriptionAfter, StyledDescriptionBefore, StyledScoreTagValue, StyledScoreTagNewValue, StyledExplanationBefore, StyledExplanationAfter, StyledExplanationDescription, getQuestionScoreValue } from './base-question-ai-change-preview.strategy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var AiUpdateQuestionChangeStrategy = /*#__PURE__*/function () {
  function AiUpdateQuestionChangeStrategy(context) {
    _classCallCheck(this, AiUpdateQuestionChangeStrategy);

    this.context = context;
  }

  _createClass(AiUpdateQuestionChangeStrategy, [{
    key: "renderBadgeIcon",
    value: function renderBadgeIcon() {
      return /*#__PURE__*/_jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z"
        })
      });
    }
  }, {
    key: "renderBadgeLabel",
    value: function renderBadgeLabel() {
      var _this$context$label$b;

      return /*#__PURE__*/_jsx("span", {
        children: (_this$context$label$b = this.context.label.badgeEdit) !== null && _this$context$label$b !== void 0 ? _this$context$label$b : 'EDIT'
      });
    }
  }, {
    key: "renderDescription",
    value: function renderDescription() {
      var _this$context$before, _this$context$after, _this$context$before2, _this$context$after2, _this$context$after3;

      var hasChanged = ((_this$context$before = this.context.before) === null || _this$context$before === void 0 ? void 0 : _this$context$before.description) !== ((_this$context$after = this.context.after) === null || _this$context$after === void 0 ? void 0 : _this$context$after.description);
      return hasChanged ? /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          gap: 4
        },
        children: [/*#__PURE__*/_jsx(StyledDescriptionBefore, {
          value: ((_this$context$before2 = this.context.before) === null || _this$context$before2 === void 0 ? void 0 : _this$context$before2.description) || ''
        }), /*#__PURE__*/_jsx(StyledDescriptionAfter, {
          value: ((_this$context$after2 = this.context.after) === null || _this$context$after2 === void 0 ? void 0 : _this$context$after2.description) || ''
        })]
      }) : /*#__PURE__*/_jsx(StyledNormalDescription, {
        value: ((_this$context$after3 = this.context.after) === null || _this$context$after3 === void 0 ? void 0 : _this$context$after3.description) || ''
      });
    }
  }, {
    key: "renderScore",
    value: function renderScore() {
      var beforeScore = getQuestionScoreValue(this.context.before);
      var afterScore = getQuestionScoreValue(this.context.after);
      var hasChanged = beforeScore !== afterScore;
      return hasChanged ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledScoreTagValue, {
          children: beforeScore
        }), /*#__PURE__*/_jsx(StyledScoreTagNewValue, {
          children: afterScore
        })]
      }) : /*#__PURE__*/_jsx(StyledScoreTagNewValue, {
        children: afterScore
      });
    }
  }, {
    key: "renderExplanation",
    value: function renderExplanation() {
      var _this$context$before3, _this$context$after4, _this$context$before4, _this$context$after5, _this$context$after6;

      var hasChanged = ((_this$context$before3 = this.context.before) === null || _this$context$before3 === void 0 ? void 0 : _this$context$before3.explanation) !== ((_this$context$after4 = this.context.after) === null || _this$context$after4 === void 0 ? void 0 : _this$context$after4.explanation);
      return hasChanged ? /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          gap: 4
        },
        children: [/*#__PURE__*/_jsx(StyledExplanationBefore, {
          value: ((_this$context$before4 = this.context.before) === null || _this$context$before4 === void 0 ? void 0 : _this$context$before4.explanation) || ''
        }), /*#__PURE__*/_jsx(StyledExplanationAfter, {
          value: ((_this$context$after5 = this.context.after) === null || _this$context$after5 === void 0 ? void 0 : _this$context$after5.explanation) || ''
        })]
      }) : /*#__PURE__*/_jsx(StyledExplanationDescription, {
        value: ((_this$context$after6 = this.context.after) === null || _this$context$after6 === void 0 ? void 0 : _this$context$after6.explanation) || ''
      });
    }
  }]);

  return AiUpdateQuestionChangeStrategy;
}();